export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/cat.5e04f0d5.svg","height":238,"width":389,"blurWidth":0,"blurHeight":0};